import { Group } from '.';

export interface DragAndDropConfig<T> {
  allowDragAndDrop: boolean;
  dynamicWidth?: boolean;
  /**
   * @description name of the field after which drag and drop will be computed
   * sets the object field equal to the position in table + 1
   */
  columnDef?: keyof T;
  columnWidth?: number;
  maxWidth?: number;
  /**
   * @description whether a dragged row may move into another group; a refused
   * drop leaves the row where it was and calls `onGroupChangeRefused`
   */
  allowGroupChange?: (data: T, group: Group) => boolean;
  onGroupChangeRefused?: (data: T, group: Group) => void;
}
